__turbopack_context__.v({
  "collapsed": "AccordionPanel-module-scss-module__7tnxeG__collapsed",
  "expanded": "AccordionPanel-module-scss-module__7tnxeG__expanded",
});
